import store from "@/store";
import { $loaderService } from "@/plugins/ELoaderService";

const ROLES_OPERACIONAIS = [
  "monitor-onibus-escolar",
  "coordenador-patio",
  "coordenador-vigilancia",
  "porteiro",
  "profissional-apoio",
];

const redirecionarSeForPontofiq = async (to, from, next) => {
  let currentUser = store.getters["Auth/user"];

  if (!currentUser) {
    await $loaderService.loadBasicDataIfNeeded();
    currentUser = store.getters["Auth/user"];
  }

  if (!currentUser) {
    return next();
  }

  const roleName = currentUser.roleName || "";

  if (roleName === "secretario-municipal-educacao") {
    if (to.name !== "colaboradores.pontos") {
      return next({ name: "colaboradores.pontos" });
    }
  } else if (ROLES_OPERACIONAIS.includes(roleName)) {
    if (to.name !== "colaboradores.meusPontos") {
      return next({ name: "colaboradores.meusPontos" });
    }
  }

  return next();
};

export default redirecionarSeForPontofiq;
